import { render, staticRenderFns } from "./FaltasDisciplinaTurmasPage.vue?vue&type=template&id=670c576a&scoped=true"
import script from "./FaltasDisciplinaTurmasPage.vue?vue&type=script&lang=js"
export * from "./FaltasDisciplinaTurmasPage.vue?vue&type=script&lang=js"
import style0 from "./FaltasDisciplinaTurmasPage.vue?vue&type=style&index=0&id=670c576a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c576a",
  null
  
)

export default component.exports